import { Component, inject } from '@angular/core';
import { User, DefaultUser } from 'src/app/models/user.model';
import { AccountService } from 'src/app/services/account.service';
import { environment } from 'src/environments/environment'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CircleProgressComponent } from '../circle-progress/circle-progress.component';

@Component({
    selector: 'app-account-overview',
    templateUrl: './account-overview.component.html',
    styleUrls: ['./account-overview.component.css'],
    imports: [NgClass, RouterLink, CircleProgressComponent, DatePipe]
})
export class AccountOverviewComponent {

  private account = inject(AccountService);

  user: User;

  progressPRC = 100;

  constructor() { this.initializeUser(); }

  initializeUser()
  {
    this.user = DefaultUser
    this.account.userObservable
      .pipe(takeUntilDestroyed())
      .subscribe(
        (next: User) => {
          if(next != null)
            this.user = next;
          else
            this.user = DefaultUser
          this.CheckProgressBar();
        }
      )
  }

  CheckProgressBar() {
    this.progressPRC = 100;
    if (!this.user.email)
      this.progressPRC -= 20;
    if (!this.user.first_name)
      this.progressPRC -= 20;
    if (!this.user.has_password )
      this.progressPRC -= 20;
    if (!this.user.has_subscribed_to_newsletter || !this.user.email)
      this.progressPRC -= 20;
    if (!this.user.has_verified_email)
      this.progressPRC -= 20;
  }

  LoginSteam()
  {
    location.href = environment.apiURL + "/login/steam";
  }

}

